import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import queryString from "query-string";
import { Link } from "react-router-dom";

import { Button } from "../../utils";
import { SuccessResetPswrd, ResendLink } from "../../HemeIconLibrary";
import { getAllQuestionsAction, verifyTokenreset } from "../../Actions/auth";
import ResendLinkForm from "../../components/resendLink";
import ResetConfirmationForm from "../AllQuestions";
import SetPasswordReset from "../setPasswordReset";

const Index = () => {
  const [verifyLink, setVerifyLink] = useState();
  const [allQuestion, setAllQuestion] = useState();
  const [allAnsweredQuestions, setAllAnsweredQuestions] = useState();
  const [token, setToken] = useState();

  useEffect(() => {
    (async () => {
      const querry = queryString.parse(window.location.search);
      const result = await verifyTokenreset(querry.token);
      if (result.data) {
        setVerifyLink("pass");
        setToken(querry.token);
      } else {
        setVerifyLink("fail");
      }
      const formulaTest = await getAllQuestionsAction(querry.token);
      console.log(formulaTest);
      if (formulaTest.status === 200) {
        setAllQuestion(formulaTest.data);
      }
    })();
  }, [window.location.search]);

  return verifyLink === "pass" ? (
    <ResetConfirmationForm allQuestion={allQuestion} token={token} setVerifyLink={setVerifyLink} setAllAnsweredQuestions={setAllAnsweredQuestions} />
  ) : verifyLink === "fail" ? (
    <div>
      <ResendLinkForm Icon={<ResendLink />} title="Reset Password" description="Looks like the link you used has expired. Please request a new one." />
    </div>
  ) : verifyLink === "set-pass" ? (
    <div>
      <SetPasswordReset
        title="Reset Password"
        description="Choose a new password"
        type="reset-password"
        allAnsweredQuestions={allAnsweredQuestions}
        token={token}
        setVerifyLink={setVerifyLink}
      />
    </div>
  ) : verifyLink === "set-pass-success" ? (
    <div className="max-w-[450px]">
      <div className="flex flex-col items-center justify-center">
        <SuccessResetPswrd />
        <h3 className="font-bold pt-[16.44px] pb-[10.38px] text-subheadingColor leading-[48px] text-[40px] font-Inter">Reset Password</h3>
        <p className="font-Inter text-center pb-[34px] text-base text-textColor leading-6 font-normal">Your password has been reset successfully.</p>
        <Link to="/login">
          <Button text="Go to Login" type="submit" bg="bg-primary1" border="border-primary1" color="text-white" className="w-full h-[48px] justify-center font-semibold" />
        </Link>
      </div>
    </div>
  ) : (
    <div>
      <h3 className="font-bold pt-[16.45px] pb-[10.38px] text-subheadingColor leading-[48px] text-[40px] font-Inter">Reset Password</h3>
      <Button
        type="submit"
        bg="bg-primary1"
        className="w-full h-[48px] justify-center font-semibold"
        text={
          <>
            <Spinner animation="grow" size="sm" variant="light" />
            <Spinner animation="grow" size="sm" variant="light" />
            <Spinner animation="grow" size="sm" variant="light" />
          </>
        }
      />
    </div>
  );
};

export default Index;
